export const ALL_OPTION_VALUE = '__all__';
export const DROPDOWN_ACTIVE_COLOR = '#1D90F5';

export const isAllSelected = (selected, allIds) => {
  if (!allIds?.length || !selected?.length) return false;
  if (selected.length !== allIds.length) return false;
  const selectedSet = new Set(
    selected
      .filter(id => id !== ALL_OPTION_VALUE)
      .map(id => String(id))
  );
  return allIds.every(id => selectedSet.has(String(id)));
};

export const isOptionSelected = (selectedValues, optionValue) =>
  (selectedValues ?? []).some(id => String(id) === String(optionValue));

export const resolveMultiSelectValue = (
  prevSelected,
  rawValue,
  allOptionIds
) => {
  const arr = typeof rawValue === 'string' ? rawValue.split(',') : rawValue;
  const hasAll = arr.includes(ALL_OPTION_VALUE);
  const filtered = arr.filter(v => v !== ALL_OPTION_VALUE);
  const wasAll = isAllSelected(prevSelected, allOptionIds);

  if (hasAll && filtered.length === 0) return [...allOptionIds];
  if (hasAll && filtered.length > 0) {
    if (wasAll && filtered.length === allOptionIds.length) return [];
    return wasAll ? filtered : [...allOptionIds];
  }
  return filtered;
};

export const buildOptionLabelMap = options =>
  Object.fromEntries((options ?? []).map(o => [o.value, o.label]));
